import { createFileRoute } from '@tanstack/react-router';
import { ProgressPage } from '@/features/finance';

/** The progress-invoice editor of a contract. "Invoice suggested" notifications link here. */
export const Route = createFileRoute('/_auth/o/$orgId/finance/contracts/$contractId/progress')({
  component: ProgressRoute,
});

function ProgressRoute() {
  const { orgId, contractId } = Route.useParams();
  return <ProgressPage orgId={orgId} contractId={contractId} />;
}
